<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item"><router-link to="/">Home</router-link></li>
    <li class="breadcrumb-item"><router-link to="/solutions/digitalinfrastructure">Digital Infrastructure</router-link></li>
    <li class="breadcrumb-item active" aria-current="page">Data Centers</li>
  </ol>
</nav>

<div class="row">

<div class="col-lg-8">
<h2 class="title">Data Centers</h2>

                <p class="lead">
                  Today, the data center is the heart of most companies’
                  operations, and the lifeline of organizations where data is
                  shared to and from users, storage devices and the worldwide
                  web. However, with ever-increasing data center size and
                  complexity, DC managers and IT professionals require the right
                  configurations and equipments to meet their specific
                  environment needs as well as solutions to assist them in
                  accessing servers, network devices and other purpose targeted
                  equipments.
                </p>
                <p class="lead">
                  We tailor specific solutions for organizations and Businesses
                </p>
                <ul class="lead">
                  <li>
                    Public Cloud: leverage the cloud to scale up and down as
                    needed. You reduce time to deploy and adopt services.
                  </li>
                  <li>
                    SD-WAN: we help connect your organization effortlessly over
                    any means with centralized management. We also help to
                    design, execute and support your next WAN Architecture.
                  </li>
                  <li>
                    Virtualization: our data centers meet the need of deploying
                    workloads faster, ensuring increased productivity and
                    availability hence making operations to become automated.
                  </li>
                  <li>
                    Data protection: we back up datas while protecting your
                    cloud-based applications hence supporting your business by
                    enabling quick retrieval of data when lost, securing and
                    easy accessibility of data..
                  </li>
                  <li>
                    Storage: Our data center also enables application
                    flexibility and replication..
                  </li>
                </ul>
                <p class="lead">
                  These products do not only help in ensuring efficiency but
                  also contribute to an overall strategy reducing company cost.
                  We can offer help to review your specific environment and help
                  you find the best infrastructure solutions for your data
                  center.
                </p>

</div>

<div class="col-lg-4">
  <DigitalInfraSideNav></DigitalInfraSideNav>
</div>
</div>
        

        </div>
      </section>
    </div>
  </div>
</template>
<script>
import DigitalInfraSideNav from "./DigitalInfraSideNav";
export default {
  name: "overview",
  components : {
    DigitalInfraSideNav
  }
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>

